// JQUERY //
window.$ = window.jQuery = require('jquery');

// AXIOS //
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// BOOTSTRAP //
require('bootstrap');
require('popper.js');

// PERFECT SCROLLBAR //
import PerfectScrollbar from 'perfect-scrollbar';

if ($('.shopping-cart-content ul').length > 0) {
    $('.shopping-cart-content ul').each(function() {
        const ps = new PerfectScrollbar($(this)[0]);
    });
}

// OWL CAROUSEL //
require('owl.carousel');

// MENU //
require('superfish');
require('jquery-hoverintent');

// JQUERY UI //
require('jquery-ui/ui/widgets/slider');

// BX SLIDER //
require('bxslider/dist/jquery.bxslider.min');

// JS SOCIALS //
require('jssocials');

// PARALLAX //
require('stellar.js');